module.exports = __webpack_public_path__ + "img/skull-head-blue.60d01407.svg";